const categorySc = [
  "法律服务",
  "会计",
  "跨境贸易争端护航计划 (1 小时免费法律咨询)",
  // "金融",
  // "商业服务",
  // "银行",
  // "保险",
  // "影视行业",
];

export default categorySc;
